/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Logo from "./../../../assets/Jobvious_logo.png";
import { RequireNewPassword } from "aws-amplify-react";
import { Auth } from "aws-amplify";

export class CustomRequireNewPassword extends RequireNewPassword {
  constructor(props) {
    super(props);
    this._validAuthStates = ["requireNewPassword"];
    this.state = {
      password: "",
      error: null
    };
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
    this.inputs = this.inputs || {};
    this.inputs.password = e.target.value;
  };

  change = async () => {
    const { password } = this.state;
    const user = this.props.authData;

    if (!password) {
      this.setState({ error: "Please enter a new password" });
      return;
    }

    try {
      const requiredAttributes = user.challengeParam?.requiredAttributes || [];
      const attrs = {};

      // Handle any required attributes
      requiredAttributes.forEach(attr => {
        if (this.inputs && this.inputs[attr]) {
          attrs[attr] = this.inputs[attr];
        }
      });

      const updatedUser = await Auth.completeNewPassword(user, password, attrs);

      if (updatedUser.challengeName === 'SMS_MFA') {
        this.changeState('confirmSignIn', updatedUser);
      } else if (updatedUser.challengeName === 'MFA_SETUP') {
        this.changeState('TOTPSetup', updatedUser);
      } else {
        // Check contact and sign in
        this.checkContact(updatedUser);
      }
    } catch (err) {
      console.error("Error changing password:", err);
      this.setState({
        error: err.message || "Failed to change password. Please try again."
      });
    }
  };

  checkContact = async (user) => {
    try {
      const data = await Auth.verifiedContact(user);
      if (data.verified && Object.keys(data.verified).length > 0) {
        this.changeState('signedIn', user);
      } else {
        const userWithData = Object.assign(user, data);
        this.changeState('verifyContact', userWithData);
      }
    } catch (err) {
      console.error("Error verifying contact:", err);
      this.changeState('signedIn', user);
    }
  };

  showComponent(theme) {
    const { error } = this.state;

    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="content p-5">
                <div className="row justify-content-md-center">
                  <div className="card col-lg-4 p5-lg">
                    <div className="card-body">
                      <h5 className="card-title text-center mb-5">
                        <img src={Logo} alt="" />
                      </h5>
                      <h6 className="card-subtitle mb-2 text-muted text-center">
                        Change Your Password
                      </h6>
                      <p className="text-center text-muted small mb-4">
                        Please set a new password for your account
                      </p>

                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}

                      {/* Form */}
                      <form>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="new-password">
                            New Password
                          </label>
                          <input
                            className="form-control"
                            id="new-password"
                            name="password"
                            type="password"
                            value={this.state.password}
                            onChange={this.handlePasswordChange}
                            autoComplete="new-password"
                            autoFocus
                            placeholder="Enter your new password"
                          />
                          <small className="form-text text-muted mt-2">
                            Password must be at least 8 characters
                          </small>
                        </div>
                        <div className="form-group">
                          <button
                            className="btn btn-outline-primary btn-block mb-3"
                            type="button"
                            onClick={this.change}
                          >
                            Change Password
                          </button>
                        </div>
                      </form>
                      {/* End Form */}

                      {/* Divider */}
                      <hr />

                      {/* Need help */}
                      <div className="text-center mt-3">
                        <p>
                          Need help?{" "}
                          <a href="mailto:support@jobvious.com?subject=Password%20Change%20Assistance&body=Hi%20Jobvious%20Support%2C%0A%0AI%20need%20help%20with%20changing%20my%20password.%0A%0AThanks!">
                            Contact Support
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col text-center">
                  <p>&copy; 2026 Jobvious, Inc </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomRequireNewPassword;
